__turbopack_context__.v({
  "className": "caveat_d0eaf3cb-module__8AZoaW__className",
  "variable": "caveat_d0eaf3cb-module__8AZoaW__variable",
});
